import types from "./types";

const openSettings = () => {
  return {
    type: types.OPEN_SETTINGS,
  };
};

const closeSettings = () => {
  return {
    type: types.CLOSE_SETTINGS
  }
}

const openDebrief = () => {
  return {
    type: types.OPEN_DEBRIEF,
  };
};

const closeDebrief = () => {
  return {
    type: types.CLOSE_DEBRIEF,
  };
};

const setSnackbarOptions = (snackbarOptions) => {
  return {
    type: types.SET_SNACKBAR,
    payload: snackbarOptions,
  };
};

export default {
  openSettings,
  openDebrief,
  closeSettings,
  closeDebrief,
  setSnackbarOptions,
};



// WEBPACK FOOTER //
// ./src/redux/nav/actions.js